import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule, Router } from "@angular/router";
import { HeaderComponent } from "./header/header.component";

@Component({
	selector: "app-layout",
	standalone: true,
	imports: [
		CommonModule,
		MatSidenavModule,
		MatListModule,
		MatIconModule,
		RouterModule,
		HeaderComponent,
	],
	templateUrl: "./layout.component.html",
	styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent {
	isSidebarOpen = true;

	constructor(private router: Router) {}

	onToggleSidebar() {
		this.isSidebarOpen = !this.isSidebarOpen;
	}

	isRouteActive(path: string): boolean {
		return this.router.url.startsWith(path);
	}
}
